export const availableAIModels = [
  {
    label: 'Claude Opus 4.5',
    value: 'global.anthropic.claude-opus-4-5-20251101-v1:0',
  },
  {
    label: 'Claude Opus 4.6',
    value: 'us.anthropic.claude-opus-4-6-v1',
  },
  {
    label: 'Claude 4 Sonnet',
    value: 'us.anthropic.claude-sonnet-4-20250514-v1:0',
  },
  {
    label: 'Claude 4.5 Sonnet',
    value: 'global.anthropic.claude-sonnet-4-5-20250929-v1:0',
  },
  {
    label: 'Claude 4.6 Sonnet',
    value: 'us.anthropic.claude-sonnet-4-6',
  },
  {
    label: 'Claude 4.5 Haiku',
    value: 'us.anthropic.claude-haiku-4-5-20251001-v1:0',
  },
  {
    label: 'GPT-6 Astra',
    value: 'openai.gpt-6-astra',
  },
  {
    label: 'GPT-6.1 Sol',
    value: 'openai.gpt-6.1-sol',
  },
  {
    label: 'GPT-6 Luna',
    value: 'openai.gpt-6-luna',
  },
  {
    label: 'Nova 2 Lite',
    value: 'us.amazon.nova-2-lite-v1:0',
  },
  {
    label: 'Kimi K3',
    value: 'us.moonshotai.kimi-k3',
  },
  {
    label: 'Kimi K2.5',
    value: 'moonshotai.kimi-k2.5',
  },
];

export const defaultModel = {
  label: 'Claude 4.5 Haiku',
  value: 'us.anthropic.claude-haiku-4-5-20251001-v1:0',
};
